const DEFAULT_MULTIPLIER = 1;

export default DEFAULT_MULTIPLIER;
